import React from "react";
import { HelpCircleIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { caseQuestions, learningSources } from "../../data/landing";
export function ProblemIntro() {
  return <section className="bg-navy px-4 py-16 text-white sm:py-24" data-id="element-271" data-mp="3hrhygsgr441i">
      <div className="mx-auto max-w-3xl" data-id="element-272" data-mp="3d0i49uz0o02p">
        <p className="text-center font-serif text-xl italic text-white/70 sm:text-2xl" data-id="element-273" data-mp="3czgqvjuj31ht">From a case that feels overwhelming…</p>
        <h2 className="mt-3 text-center font-serif text-[1.9rem] font-extrabold leading-[1.12] sm:text-5xl" data-id="element-274" data-mp="3qq3fukahld0p">
          …to a case you can review with a <span className="text-gold" data-id="element-275" data-mp="4kg8xip0597t">structured process.</span>
        </h2>

        <p className="mt-8 text-center text-lg leading-relaxed text-white/80" data-id="element-276" data-mp="4ic6l56r4i9n">
          When you're looking at a liposuction case, the challenge isn't always finding more information. Sometimes the real
          challenge is knowing:
        </p>

        <ul className="mt-6 space-y-3" data-id="element-277" data-mp="21e06vchuej2j">
          {caseQuestions.map(q => <li key={q} className="flex items-start gap-3 rounded-xl bg-white/[0.06] px-4 py-3.5 text-[17px] font-semibold" data-id="element-278" data-mp="1kbwwo24kb1t7">
              <HelpCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-279" data-mp="1pb9lutiwokyy" />
              {q}
            </li>)}
        </ul>

        <div className="mt-12 border-t border-white/15 pt-10 text-center" data-id="element-280" data-mp="1y2jln2kitdc3">
          <p className="text-sm font-bold uppercase tracking-[0.14em] text-gold" data-id="element-281" data-mp="1y4w9txgvgjxl">6 volumes + 5 bonuses + 30+ planning tools</p>
          <p className="mt-5 text-lg leading-relaxed text-white/80" data-id="element-282" data-mp="280pmrhyi6ffw">I created Lipo Planning Workbook™ because I kept seeing the same problem:</p>
          <ul className="mt-5 space-y-1.5 font-serif text-xl text-white/90" data-id="element-283" data-mp="2d0kdnlia350y">
            {learningSources.map(s => <li key={s} data-id="element-284" data-mp="2gzjotnulry0u">{s}</li>)}
          </ul>
          <p className="mt-6 text-lg text-white/80" data-id="element-285" data-mp="in2v6cwqcycs">And then a new patient comes in… and you still have to figure out:</p>
          <p className="mt-3 font-serif text-3xl font-bold italic text-gold" data-id="element-286" data-mp="mnwmlg9dsvaf">Where do I start?</p>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-white/80" data-id="element-287" data-mp="1pyskrjq9vvbo">
            The problem isn't a lack of knowledge. It's the lack of a{" "}
            <strong className="text-white" data-id="element-288" data-mp="1yzgz6fjkvxp3">repeatable planning process.</strong> That's exactly what this workbook gives you.
          </p>
        </div>

        <div className="mt-10" data-id="element-289" data-mp="1uzq25u3gklc4">
          <CtaButton label="I want to plan my cases with a system" data-id="element-290" data-mp="28wv3jgs88w11" />
        </div>
      </div>
    </section>;
}